var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceUnavailable = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.708 129.335 13.744 3.471c2.07.523 3.987-1.267 3.609-3.367L56.612 65.818a2.936 2.936 0 0 0-2.35-2.366l-15.517-2.904c-2.056-.385-3.844 1.442-3.414 3.489l13.222 63.054a2.937 2.937 0 0 0 2.155 2.244Z",
    fill: "#fff",
    stroke: "#07F",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31.666 148.044-13.994-3.645a2.936 2.936 0 0 1-2.136-3.437l11.585-55.946a2.937 2.937 0 0 1 2.335-2.29l15.57-2.914c2.056-.385 3.844 1.444 3.413 3.491l-13.16 62.505a2.936 2.936 0 0 1-3.613 2.236ZM156.805 156.16l13.745 3.471c2.069.523 3.987-1.266 3.609-3.367L162.71 92.643a2.936 2.936 0 0 0-2.35-2.366l-15.518-2.904c-2.056-.385-3.843 1.442-3.414 3.489l13.222 63.054a2.937 2.937 0 0 0 2.155 2.244Z",
    fill: "#fff",
    stroke: "#07F",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m137.764 174.869-13.995-3.645a2.936 2.936 0 0 1-2.135-3.437l11.584-55.945a2.936 2.936 0 0 1 2.336-2.291l15.569-2.914c2.057-.385 3.844 1.444 3.413 3.491l-13.159 62.505a2.935 2.935 0 0 1-3.613 2.236Z",
    fill: "#fff",
    stroke: "#07F",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m174.978 78.921-.004 31.469a2.937 2.937 0 0 1-1.528 2.577l-8.525 4.658a2.935 2.935 0 0 1-2.298.222L27.908 75.012A2.936 2.936 0 0 1 26 73.105L17.74 47.18a2.936 2.936 0 0 1 1.492-3.521l10.1-5.016a2.936 2.936 0 0 1 1.996-.224L169.36 71.785a7.341 7.341 0 0 1 5.617 7.136Z",
    fill: "#fff",
    stroke: "#07F",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m165.724 82.641-.003 32.932a2.936 2.936 0 0 1-3.657 2.846L19.424 82.325a2.936 2.936 0 0 1-2.217-2.847l.004-32.931a2.936 2.936 0 0 1 3.657-2.846l142.64 36.093a2.936 2.936 0 0 1 2.216 2.847Z",
    fill: "#fff",
    stroke: "#07F",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.385 83.514 16.352 65.192V49.619l1.423-5.442 27.38 44.62-17.77-5.283ZM61.918 92.553 34.152 46.676l16.828 4.019 28.706 47.14-17.768-5.282ZM97.164 102.67 69.398 56.792l16.828 4.019 28.707 47.141-17.77-5.282ZM130.664 109.874l-27.766-45.878 16.828 4.019 28.707 47.141-17.769-5.282ZM164.661 117.445l-27.532-44.563 16.827 4.019 11.32 15.413-.615 25.131ZM31.453 147.161l12.703-58.082h2.981l-12.608 58.346-3.076-.264ZM68.203 131.764 60.958 91.69h-2.98l7.15 40.337 3.075-.263ZM174.3 158.326l-7.245-40.073h-2.981l7.15 40.337 3.076-.264ZM137.129 174.163l12.703-58.082h2.981l-12.608 58.346-3.076-.264Z",
    fill: "#07F"
  })));
};
export default SvgServiceUnavailable;